<template>
  <div class="whiteBg" :style="{padding}">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'white-bg',
    props: {
      padding: {
        type: String,
        default: '30px'
      }
    }
  }
</script>

<style scoped>
  .whiteBg {
    background: #FFFFFF;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.04);
    border-radius: 10px;
  }
</style>
